module.exports = __webpack_public_path__ + "img/lqsxtou_2.2eb05b80.svg";